// extracted by mini-css-extract-plugin
module.exports = {"container":"header_container__1clgn"};